import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import api from './services/api';
import Header from './components/Header';
import ControlBtn from './components/ControlBtn';
import GeraTabela from './components/GeraTabela';
import CreateCards from './components/CreateCards';
import ProximaLeitura from './components/ProximaLeitura';
import { Modal } from 'react-bootstrap';


function App() {
    
    const [data, setData] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {

        const url = window.location.search;
        const urlParametro = new URLSearchParams(url);
        const cd_posto = urlParametro.get('postos');
        let cd_tipo;
        let localTipo = localStorage.getItem("tipo");

        if (localTipo !== null) {
            cd_tipo = localTipo;
        } else {
            cd_tipo = 2;
            localStorage.setItem("tipo", cd_tipo);
        }

        async function fetchData() {

            if (cd_posto === null) {
                cd_tipo = ""
            }

            try {
                const response = await api.get(`/monitor/atraso?postos=${cd_posto}&tipo=${cd_tipo}`)
                setData(response.data);
                //console.log(response.data);
            } catch (e) {
                console.log("deu erro")
                handleShow();
                console.error(e);
            }
        }
        fetchData();
    }, []);

    async function atualizaTipo(filtro) {
        const url = window.location.search;
        const urlParametro = new URLSearchParams(url);
        const cd_posto = urlParametro.get('postos');
        localStorage.setItem("tipo", filtro);

        try {
            const response = await api.get(`/monitor/atraso?postos=${cd_posto}&tipo=${filtro}`)
            setData(response.data);
        } catch (e) {
            console.error(e);
        }
    }

    function acertaHora(tempo) {

        const hora = parseInt(tempo / 60);
        const minuto = parseInt(tempo % 60);

        return ("00" + hora.toString()).slice(-2) + ":" + ("00" + minuto.toString()).slice(-2);
    }



    function alteraCorIcone(time_decorrido, time) {
        let cor = "";

        if (time_decorrido <= (time / 3)) {
            cor = "dark-Status";
        } else if (time_decorrido <= (time / 3 * 2)) {
            cor = "blue-Status";
        } else if (time_decorrido <= time) {
            cor = "yellow-Status";
        } else {
            cor = "red-Status";
        }

        return cor;
    }

    return (
        <>
            {/* começa Modal*/}
            <Modal show={show} onHide={handleClose}>

                <Modal.Body className="text-center Color-modal" text="white">
                    Erro!
                    <br />
                    Não foi encontrado o códio do Posto ou tipo!
                </Modal.Body>

            </Modal>
            {/* começa o  Header */}
            <Header />
            <main>
                <div>
                    {/* começa Cronômetro*/}
                    <ProximaLeitura />
                </div>
                {/* começa Painel de Status dos exames*/}
                <div className="Painel-cads">
                    <CreateCards data={data} />
                </div>
                {/* começa Botões de filtro*/}
                <div className="Bt-filtro">
                    <ControlBtn atualizaTipo={atualizaTipo} />
                </div>
                {/* começa Tabela*/}
                <div className="Painel-table">
                    <GeraTabela data={data} acertaHora={acertaHora} corIcon={alteraCorIcone} />
                </div>
            </main>
        </>
    );

}

export default App;